import { FC } from 'react';
import { Group, ThemeIcon, Tooltip } from '@mantine/core';
import { IconBallpen, IconCheck, IconCurrencyEuro, IconExclamationMark } from '@tabler/icons';
import { DocumentDto } from '../../../Service/DocumentT';
import { DocumentS } from '../../../Templates/Documents/DocumentS';
import DocumentBookkeepingStatusIcon from './DocumentBookkeepingStatusIcon';

const DocumentIcon: FC<{ bookitupDocument: DocumentDto }> = ({ bookitupDocument }) => {
  const { draft, hasPayments, paid, acceptedAt, documentType, hasReminders } = bookitupDocument;

  const getPrimaryIcon = () => {
    if (draft) {
      return (
        <ThemeIcon radius="xl" size="sm" color="silver">
          <IconBallpen size={14} />
        </ThemeIcon>
      );
    }
    if (hasReminders && !paid) {
      return (
        <Tooltip label="Rechnung hat mindestens eine Mahnung" position="right-start" transition="slide-right">
          <ThemeIcon color="red" radius="xl" size="sm">
            <IconExclamationMark size={14} />
          </ThemeIcon>
        </Tooltip>
      );
    }
    if (!hasPayments) {
      return (
        <ThemeIcon color={acceptedAt ? 'green' : 'blue'} radius="xl" size="sm">
          <IconCheck size={14} />
        </ThemeIcon>
      );
    }
    return (
      <ThemeIcon radius="xl" size="sm" color={paid ? 'green' : 'yellow'}>
        <IconCurrencyEuro size={14} />
      </ThemeIcon>
    );
  };

  return (
    <Group spacing={5}>
      {getPrimaryIcon()}
      {DocumentS.isInvoice(documentType) && <DocumentBookkeepingStatusIcon />}
    </Group>
  );
};

export default DocumentIcon;
